import { Link } from 'react-router-dom';
import { hotKeywords } from '@/mocks/siteData';
import { newsList } from '@/mocks/newsData';

export default function MarketBrief() {
  const latest = newsList.slice(0, 4);

  return (
    <aside className="flex flex-col gap-4">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>
          热门关键词
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotKeywords.map((word) => (
            <Link
              key={word}
              to={`/search?q=${encodeURIComponent(word)}`}
              className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {word}
            </Link>
          ))}
        </div>
      </div>

      <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
            <i className="ri-pulse-line text-primary-600" aria-hidden="true"></i>
            最新快讯
          </h3>
          <Link to="/category/investment-news" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">
            更多
          </Link>
        </div>
        <ul className="mt-3 divide-y divide-background-200">
          {latest.map((news) => (
            <li key={news.id} className="py-3 first:pt-0 last:pb-0">
              <Link to={`/detail/news/${news.id}`} className="group flex gap-2">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500"></span>
                <span className="min-w-0">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                    {news.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-400">{news.date}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}